import liPaging from "./Paging.vue";
import liTableText from "./tabletext.vue";
import liDialogCard from "./dialogCard.vue"
import liImgUpload from "./ImageListUpload.vue"

const components = {
    liPaging,
    liDialogCard,
    liTableText,
    liImgUpload
}


function install(Vue) {
    const keys = Object.keys(components);
    keys.forEach(name => {
        const component = components[name];
        Vue.component(component.name || name, component)
    })
}

export default {
    install,
    ...components
}
